import React from "react";
import InputComponent from "../input";

function AddressField(props){

    return <div className={'w-100 d-flex pt-2'}>

        <InputComponent
            id={props.id}
            type={'text'}
            name={'address#' + props.id}
            value={props.value.address}
            onChange={(e) => props.onChange(props.id, e, 'address')}
            placeholder={props.placeholder}
            class={'form-control w-75 rounded-0 border-0 border-bottom border-end'}
        />

        <InputComponent
            id={props.id}
            type={'text'}
            name={'address-note#' + props.id}
            value={props.value.note}
            onChange={(e) => props.onChange(props.id, e, 'note')}
            placeholder={'Примітка'}
            class={'form-control w-25 rounded-0 border-0 border-bottom'}
        />

    </div>;
}

export default AddressField;
